import { render, staticRenderFns } from "./PatientsSidebar.vue?vue&type=template&id=e2687684&"
import script from "./PatientsSidebar.vue?vue&type=script&lang=js&"
export * from "./PatientsSidebar.vue?vue&type=script&lang=js&"
import style0 from "./PatientsSidebar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports